module.exports = __webpack_public_path__ + "static/media/email.b62d4e43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/email.svg
// module id = 255
// module chunks = 0